/**
 * Removes the static startup shell painted by `index.html` (`#fad-boot`).
 *
 * It is called from an effect in <App/>, i.e. AFTER React has committed its
 * first render — so there is never a frame where neither the static shell nor
 * the React tree is on screen. The node is removed, not hidden, so it cannot
 * intercept clicks or be read by screen readers afterwards.
 */

export function removeBootShell(): void {
  if (typeof document === "undefined") return;
  document.getElementById("fad-boot")?.remove();
}
